import React, {memo, useState} from "react";
import {useMemberships} from "../../../Api/groups";
import ContentBox from "../../../../../Components/ContentBox/ContentBox";
import {SimplexionTable} from "../../../../simplexion-table/SimplexionTable";
import {baseTableStyles} from "../../../../simplexion-table/baseStyle";
import {makeStyles} from "@material-ui/core";
import {customActions} from "../../../../simplexion-table/templates/action-buttons";
import {makeTableStyles} from "../../../../../Components/Table/tableStyles";
import {updatableCheckBoxStyle} from "../../../../simplexion-table/templates/checkbox-input";
import {inputFieldStyles} from "../../../../simplexion-table/templates/text-input";
import debug from "../../../../debug";
import {FilterField} from "../../../../../Components/Table/FilterField";
import LinearProgress from "@material-ui/core/LinearProgress";

const useTableStyles = makeStyles(makeTableStyles(baseTableStyles, updatableCheckBoxStyle, inputFieldStyles));

const List = memo((props) => {

    debug("RENDER", "useForm", () => [" -> List_Of_Memberships", props]);

    const {path, parentId} = props;

    const tableClasses = useTableStyles();

    const urlNs = path[2].url + "/";

    const [state, setState] = useState('');

    const {loadingStatus, data} = parentId ? useMemberships(parentId) : [];

    const handleFilter = val => setState(val);

    const tableConfig = {
        id: 'memberships-table',
        nameSpace: 'memberships',
        stickyHeader: true,
        sortable: true,
        styles: tableClasses,
        columns: [
            {
                accessor: 'id',
            },
            {
                accessor: 'principalName',
            },
            {
                accessor: 'fullName',
            },
            {
                accessor: 'emailAddress',
            },
            {
                accessor: 'action',
                renderer: (...args) => customActions(false, true, urlNs, ...args),
                sortable: false,
            },
        ],
    };

    return (
        <ContentBox path={path} add={urlNs + "add"}>
            <FilterField handler={handleFilter}/>
            {loadingStatus > 0 ? <LinearProgress/> : null}
            <SimplexionTable tableConfig={tableConfig} data={data} loadingStatus={loadingStatus} filterValue={state}/>
        </ContentBox>
    );
});

export default List;